import type { NavigateFunction } from 'react-router-dom'
import type { Task } from '../schemas/task'
import { completeTask } from '../services/mutations'

export type HandlerContext = {
  navigate: NavigateFunction
  openManualForm: (prefill?: Partial<Task>) => void
}

export type HandlerFn = (task: Task, ctx: HandlerContext) => Promise<void>

const projectUrl = (id: number | null) =>
  id != null ? `/projects/edit/${id}` : '/projects'

const urbanAnalysisUrl = (analysisId: string | null) =>
  analysisId ? `/urban-analysis/edit/${analysisId}` : '/urban-analysis'

export const ACTION_HANDLERS = {
  sendReminder: async (task) => {
    await completeTask(task.id)
  },
  sendPostRdvBundle: async (task) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('autoriz.post-rdv.open', { detail: task }))
    }
    await completeTask(task.id)
  },
  openVerifyView: async (task, ctx) => {
    ctx.navigate(projectUrl(task.projectId))
  },
  openProject: async (task, ctx) => {
    ctx.navigate(projectUrl(task.projectId))
  },
  openUrbanAnalysis: async (task, ctx) => {
    // Standalone-analysis tasks store the analysis id in `meta`. For
    // project-linked analyses we fall back to the project page.
    if (task.meta) {
      ctx.navigate(urbanAnalysisUrl(task.meta))
      return
    }
    ctx.navigate(projectUrl(task.projectId))
  },
  startDrafting: async (task, ctx) => {
    ctx.navigate(projectUrl(task.projectId))
  },
  markDone: async (task) => {
    await completeTask(task.id)
  },
  openEditManual: async (task, ctx) => {
    ctx.openManualForm(task)
  },
  __noop__: async () => {
    // intentional — used by fallback kind
  },
} as const satisfies Record<string, HandlerFn>

export type HandlerId = keyof typeof ACTION_HANDLERS

export const getHandler = (handlerId: string): HandlerFn =>
  (ACTION_HANDLERS as Record<string, HandlerFn>)[handlerId] ?? ACTION_HANDLERS.__noop__
